import React from 'react'
import Admin from './Routes/Admin'
import Home from './Routes/Home'
import Store from './Routes/Store'
import ProductStore from './Routes/ProductStore'
import UsersRoute from './Routes/Users/UsersRoute'
import { RoleAccessProvider } from './Context/RoleAccessContext'

const App = () => {
  return (

    <>
      <RoleAccessProvider>
        <>
          <Home />
          <Store />
          <ProductStore />
          <UsersRoute />
          <Admin />
        </>
      </RoleAccessProvider>
    </>
  )
}

export default App